module.exports = "/_next/static/images/kickoff-word-only-white-6af700d76b8a33ea444e9ea4aae8e8b9.svg";